<template>
	<div>

	<el-container class="data_skc">

		<el-aside class="aside-style" width="200px">
			<common-nav selec="1"></common-nav>
		</el-aside>
		
		<el-container>

			<el-header class="common_header">
				<common-header></common-header>
			</el-header>
			
			<el-main>

				<el-row :gutter="24" class="page_bar">
					<el-col :span="20" class="page_bar_title">
						<i @click="handleGoBack()" class="el-icon-back showhand" style="font-size:22px"></i>  
						<span v-if="detailData.flag == 1">
						<strong v-if="detailData.status == 1">【正常】</strong>
						<strong v-if="detailData.status == 0">【结束】</strong>
						</span>
						{{detailData.topics_name}}
					</el-col>
					<el-col :span="4"></el-col>
				</el-row>

				<el-row :gutter="24" style="margin-top:10px">
					<el-col :span="19">
						<el-descriptions class="margin-top" :column="2" size="medium" border>
							<el-descriptions-item>
								<template slot="label">
									参与人数
								</template>
								{{userCount}}
							</el-descriptions-item>
							
							<el-descriptions-item>
								<template slot="label">
									活动类型
								</template>
								<span v-if="topics_singup_type == 'pp'">品牌活动</span>
								<span v-if="topics_singup_type == 'px'">培训活动</span>
								报名
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									创建人
								</template>
								{{topics_user_name}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									创建日期
								</template>
								{{topics_datetime}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									活动日期
								</template>
									{{detailData.start_date.slice(0,10) }} 至 {{detailData.end_date.slice(0,10)}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									活动日期提示
								</template>
								{{detailData.date_tips}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									住宿选项
								</template>
								<strong v-if="detailData.switch_room == 'y'">开启</strong>
								<strong v-if="detailData.switch_room == 'n'">关闭</strong>
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									用户可修改自己提交内容
								</template>
								<strong v-if="detailData.is_self_edit == 'y'">开启</strong>
								<strong v-if="detailData.is_self_edit == 'n'">关闭</strong>
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									专题链接
								</template>
								<a target="_blank" :href="'https://www.subudian.com/#/singup?uid='+topicsLink">https://www.subudian.com/#/singup?uid={{topicsLink}}</a>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
					<el-col :span="5">
						<img v-if="topicsQrcode" :src="'https://api.subudian.com/uploads/' + topicsQrcode + '.png'" width="200px">
						<img v-if="!topicsQrcode" src="https://api.subudian.com/uploads/default_code.jpg" width="200px">
					</el-col>
				</el-row>

				<div class="detail_row">
					<div style="float:left;" v-if="detailData.flag == 1">
						<el-button type="success" v-if="detailData.status == 0" @click="handleOpenTopics" size="small" >开启活动</el-button>
						<el-button type="warning" v-if="detailData.status == 1" @click="handleCloseTopics" size="small" >关闭活动</el-button>
						<el-button type="primary" @click="handleEditTopics" size="small" >修改活动信息</el-button> 
						<el-button type="primary"  size="small" icon="el-icon-paperclip" @click="handleShowUploadTopicsFile" >管理附件</el-button>
					</div>
					<!-- http://localhost:666/public/subudian/index/ -->
					<!-- https://api.subudian.com/subudian/index/ -->

					<form :action="'https://api.subudian.com/subudian/index/exportFinanceExcel?uuid='+detailData.uuid" method="post" enctype="multipart/form-data">
						<!-- <input type="hidden" id="uuid" name="uuid" value="{{detailData.uuid}}" > -->
						<input type="submit" value="导出财务专用Excel" class="buttonexcel_caiwu">
					</form>

					<form :action="'https://api.subudian.com/subudian/index/exportExcel?uuid='+detailData.uuid" method="post" enctype="multipart/form-data">
						<!-- <input type="hidden" id="uuid" name="uuid" value="{{detailData.uuid}}" > -->
						<input type="submit" value="导出报名信息Excel" class="buttonexcel">
					</form>

					
					<!-- <el-button disabled type="primary" size="mini">导出Ecxel</el-button> -->
					<!-- <el-button type="danger" size="mini">结束活动</el-button> -->
					<div class="clear"></div>
				</div>

				<el-tabs  class="mt20" v-model="activeName">
					<el-tab-pane label="活动数据" name='customer'>
						<el-button type="success" size="mini" plain @click="handleAddRowData">添加报名人</el-button>
						<el-table
							:data="detailList"
							border
							style="width: 100%;margin-top: 8px;" stripe size="mini">

							<el-table-column
							prop="id"
							label="数据ID"
							width="50">
							</el-table-column>
							<el-table-column
							prop="company_name"
							label="公司名称">
							</el-table-column>
							<el-table-column
							prop="name"
							label="参训人姓名">
							</el-table-column>
							<el-table-column
							prop="dept"
							label="部门">
							</el-table-column>
							<el-table-column
							prop="duty"
							label="职务">
							</el-table-column>
							<el-table-column
							prop="sex"
							label="性别">
							</el-table-column>
							<el-table-column
							prop="phone"
							label="手机号">
							</el-table-column>
							<el-table-column
							prop="email"
							label="邮箱">
							</el-table-column>
							<el-table-column
							prop="needroom"
							label="需要住宿">
							</el-table-column>
							<el-table-column
							prop="room_type"
							label="房型">
							</el-table-column>
							<el-table-column
							prop="spell_room"
							label="是否拼房">
							</el-table-column>
							<el-table-column
							prop="roommate_type"
							label="拼房方式">
							</el-table-column>
							<el-table-column
							prop="roommate_name"
							label="同住人姓名">
							</el-table-column>
							<el-table-column
							prop="roommate_phone"
							label="同住人手机号（后四位）">
							</el-table-column>
							<el-table-column
							prop="end_change_room"
							label="结束时是否更换">
							</el-table-column>

							<el-table-column
							prop="checkin"
							label="入住时间">
							</el-table-column>
							<el-table-column
							prop="checkout"
							label="离店时间">
							</el-table-column>


							<el-table-column
							prop="contact_name"
							label="联系人">
							</el-table-column>
							<el-table-column
							prop="contact_phone"
							label="手机号">
							</el-table-column>
							<el-table-column
							prop="contact_email"
							label="接收发票邮箱">
							</el-table-column>
							<el-table-column
							prop="contact_tax_title"
							label="发票抬头">
							</el-table-column>
							<el-table-column
							prop="contact_tax_no"
							label="税号">
							</el-table-column>
							<el-table-column
							prop="remark"
							label="备注">
							</el-table-column>
							<el-table-column
							prop="contact_tax_bank"
							label="开户行">
							</el-table-column>
							<el-table-column
							prop="contact_tax_number"
							label="银行账户">
							</el-table-column>
							<el-table-column
							prop="contact_tax_address"
							label="地址">
							</el-table-column>
							<el-table-column
							prop="contact_tax_tel"
							label="联系电话">
							</el-table-column>
							<el-table-column
							prop="contact_tax_type"
							label="发票类型">
							</el-table-column>
							<el-table-column
							prop="contact_tax_remark"
							label="发票特殊备注">
							</el-table-column>


							<el-table-column
							label="操作" fixed="right" width="160" >
								<template slot-scope="scope">
									<el-button type="warning" plain size="mini" @click="handleEditRowData(scope.row)" >修改</el-button>
									<el-button type="danger" plain size="mini" @click="handleDelRowData(scope.row)" >删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
					<!-- <el-tab-pane label="参与客户">参与客户</el-tab-pane> -->
					<!-- 
					<el-tab-pane label="角色管理">角色管理</el-tab-pane>
					<el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane> -->
				</el-tabs>
			</el-main>

			<el-footer> copyright &copy; baibaodu.com </el-footer>
		</el-container>
	</el-container>

	<el-dialog title="修改资料"  width="70%" :close-on-click-modal="false" :visible.sync="dialogEditSingupVisible">
		
		<el-row :gutter="20" class="pcpk">
				<el-col :span="11">公司名称：
					<el-input type="text" size="medium" v-model="sbd_company_name" maxlength="200"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="8">参训人姓名：
					<el-input type="text" size="medium" v-model="sbd_name" maxlength="50"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="4">性别：
					<el-select size="medium"  v-model="sbd_sex" placeholder="请选择">
						<el-option
						v-for="itema in sex_list"
						:key="itema.value"
						:label="itema.label"
						:value="itema.value">
						</el-option>
					</el-select>
				</el-col>
			</el-row>
			<el-row :gutter="20" class="pcpk">
				<el-col :span="5">部门：
					<el-input type="text" size="medium" v-model="sbd_dept" maxlength="80"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="5">职务：
					<el-input type="text" size="medium" v-model="sbd_duty" maxlength="80"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="5" :offset="1">手机号：
					<el-input type="text" size="medium" v-model="sbd_phone" maxlength="11"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="7">邮箱：
					<el-input type="text" size="medium" v-model="sbd_email" maxlength="100"  placeholder="请输入内容"></el-input>
				</el-col>
			</el-row>

			<div class="roomdata" v-if="switch_room == 'y'" >
				<el-row :gutter="20" class="pcpk">
					<el-col :span="20">需要住宿：
						<el-radio v-model="sbd_needroom" label="1">是</el-radio>
						<el-radio v-model="sbd_needroom" label="0">否</el-radio>
					</el-col>
				</el-row>
				<div v-if="sbd_needroom == '1'">
					<el-row :gutter="20" class="pcpk">
						<el-col :span="12"><span class="red_dot">*</span>选择房型：
							<el-select size="medium"  v-model="sbd_room_type" placeholder="请选择"  @change="handleSetEditRoomData">
								<el-option
								v-for="items in room_list"
								:key="items.value"
								:label="items.label"
								:value="items.value">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="12" v-if="sbd_room_type == '标间'"><span class="red_dot">*</span>是否拼住：
							<el-radio v-model="sbd_spell_room" label="1">是</el-radio>
							<el-radio v-model="sbd_spell_room" label="0">否</el-radio>
						</el-col>

						<el-row :gutter="20" class="pcpk" v-if="sbd_spell_room == 1">
							<el-col :span="22" :offset="1" class="spell_detail">
								<el-radio-group v-model="sbd_roommate_type">
									<div class="checked_row">
										<el-radio :label="1">填写同住人</el-radio>
										<el-row :gutter="20" style="margin-top: 15px;">
											<el-col :span="8">
												<div class="checked_row_label">同住人姓名：</div>
												<el-input type="text" size="small" v-model="sbd_roommate_name" maxlength="20" placeholder="请输入内容"></el-input>
											</el-col>
											<el-col :span="15">
												<div class="checked_row_label">同住人手机尾号（后四位）：</div>
												<el-input type="text" size="small" v-model="sbd_roommate_phone" maxlength="4" placeholder="请输入内容"></el-input>
											</el-col>
										</el-row>
									</div>

									<div class="checked_row">
										<el-radio :label="2">无，系统匹配同性别拼住人</el-radio>
										<div class="panel_end_change_room" v-if="sbd_roommate_type == 2">
											<div class="soq_sss">若<strong>报名截止前</strong>未能匹配到拼住人，是否更换为大床房：</div>
											<el-radio-group v-model="sbd_end_change_room">
												<el-radio :label="'y'" class="ixx_row">是，更换为大床房</el-radio>
												<el-radio :label="'n'" class="ixx_row">否，保持标间</el-radio>
											</el-radio-group>
										</div>
									</div>

									<div class="clear"></div>
								</el-radio-group>
							</el-col>
						</el-row>

					</el-row>

					<el-row :gutter="20" class="pcpk">
						<el-col :span="12"><span class="red_dot">*</span>入住时间：
							<el-date-picker
								v-model="sbd_checkin"
								type="date"
								placeholder="选择日期" size="medium" style="width: 99%;" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
							</el-date-picker>
						</el-col>
						<el-col :span="12"><span class="red_dot">*</span>离店时间：
							<el-date-picker
								v-model="sbd_checkout"
								type="date"
								placeholder="选择日期" size="medium" style="width: 99%;" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
							</el-date-picker>
						</el-col>
					</el-row>
				</div>
			</div>

			<el-row :gutter="10" class="pcpk">
				<el-col :span="6">联系人：
					<el-input type="text" size="medium" v-model="sbd_contact_name" maxlength="50"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="9">手机号：
					<el-input type="text" size="medium" v-model="sbd_contact_phone" maxlength="11"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="9">接收发票邮箱：
					<el-input type="text" size="medium" v-model="sbd_contact_email" maxlength="100"  placeholder="请输入内容"></el-input>
				</el-col>
			</el-row>

			<el-row :gutter="20" class="pcpk">
				<el-col :span="10">发票抬头：
					<el-input type="text" size="medium" v-model="sbd_contact_tax_title" maxlength="200"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="9">税号：
					<el-input type="text" size="medium" v-model="sbd_contact_tax_no" maxlength="40"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="5" style="padding-top: 15px;">发票类型：
					<el-radio v-model="sbd_contact_tax_type" label="z">专票</el-radio>
					<el-radio v-model="sbd_contact_tax_type" label="p">普票</el-radio>
				</el-col>
			</el-row>

			<el-row :gutter="20" class="pcpk" >
				<el-col :span="14">银行账号：
					<el-input type="text" size="medium" v-model="sbd_contact_tax_number" maxlength="80"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="10">开户行：
					<el-input type="text" size="medium" v-model="sbd_contact_tax_bank" maxlength="140"  placeholder="请输入内容"></el-input>
				</el-col>

			</el-row>

			<el-row :gutter="20" class="pcpk" >
				<el-col :span="14">地址：
					<el-input type="text" size="medium" v-model="sbd_contact_tax_address" maxlength="220"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="10">电话：
					<el-input type="text" size="medium" v-model="sbd_contact_tax_tel" maxlength="15"  placeholder="请输入内容"></el-input>
				</el-col>
			</el-row>

			<div class="in_body_panel">
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24">发票特殊备注：
						<el-input type="textarea" :rows="2" size="medium" v-model="sbd_contact_tax_remark" maxlength="220" show-word-limit placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>
			</div>

			<div class="in_body_panel">
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24">备注：
						<el-input type="textarea" :rows="3" size="medium" v-model="sbd_remark" maxlength="220" show-word-limit placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>
			</div>


		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogEditSingupVisible = false">取 消</el-button>
			<el-button type="primary" @click="handleSaveEditSingupData">确 定</el-button>
		</div>
	</el-dialog>

	<el-dialog :title="dialogSingupTitle" :visible.sync="dialogSingupDataVisible">

		<el-row :gutter="20" class="sixo">
			<el-col :span="24"><span class="red_dot">*</span>活动类型：
				<span v-if="topics_singup_type == 'px'">培训活动</span>
  				<span v-if="topics_singup_type == 'pp'">品牌活动</span>
			</el-col>
		</el-row>

		<el-row :gutter="20" class="sixo">
			<el-col :span="24"><span class="red_dot">*</span>活动名称：
				<el-input type="text" size="small" v-model="input_singup_title" maxlength="200" show-word-limit placeholder="请输入内容"></el-input>
			</el-col>
		</el-row>
		<el-row :gutter="20" class="sixo">
			<el-col :span="7">
				<el-switch  v-model="switch_room" active-value="y" inactive-value="n" active-color="#13ce66" active-text="开启住宿选项"></el-switch>
			</el-col>
			<el-col :span="9">
				<el-switch v-model="switch_is_self_edit" active-value="y" inactive-value="n" active-color="#13ce66" active-text="用户可修改提交的内容"></el-switch>
			</el-col>
		</el-row>
		<el-row :gutter="20" class="sixo">
			<el-col :span="24">活动简介：
				<el-input type="textarea" :rows="6" size="small" v-model="input_singup_introduction" maxlength="6000" show-word-limit placeholder="请输入内容"></el-input>
			</el-col>
		</el-row>
		<el-row :gutter="20" class="sixo">
			<el-col :span="24"><span class="red_dot">*</span>活动日期：
				<el-date-picker
					v-model="topics_date"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期" size="medium"  value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width: 99%;">
				</el-date-picker>
			</el-col>
		</el-row>
		<el-row :gutter="20" class="sixo">
			<el-col :span="24"><span class="red_dot">*</span>活动日期提示（会显示到报名页面上）：
				<el-input type="text" size="small" v-model="topics_date_tips" maxlength="200" show-word-limit placeholder="请输入内容"></el-input>
			</el-col>
		</el-row>

		<el-row :gutter="20" class="sixo" v-if="check_power == '2'" >
			<el-col :span="24">
				将活动指派给（此选项超管权限可见，普通用户只能创建自己的活动）：
				<el-select size="small"  v-model="input_singup_user_uuid" placeholder="请选择">
					<el-option
					v-for="item in user_list"
					:key="item.value"
					:label="item.label"
					:value="item.value">
					</el-option>
				</el-select>
			</el-col>
		</el-row>
		
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogSingupDataVisible = false">取 消</el-button>
			<el-button type="primary" @click="handleSaveSingupData">确 定</el-button>
		</div>
	</el-dialog>

	<el-dialog title="添加报名人" width="70%" :close-on-click-modal="false" :visible.sync="dialogAddSingupVisible">
		
		<el-row :gutter="20" class="pcpk">
				<el-col :span="11">公司名称：
					<el-input type="text" size="medium" v-model="newrow_company_name" maxlength="200"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="8">参训人姓名：
					<el-input type="text" size="medium" v-model="newrow_name" maxlength="50"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="4">性别：
					<el-select size="medium"  v-model="newrow_sex" placeholder="请选择">
						<el-option
						v-for="itema in sex_list"
						:key="itema.value"
						:label="itema.label"
						:value="itema.value">
						</el-option>
					</el-select>
				</el-col>
			</el-row>
			<el-row :gutter="20" class="pcpk">
				<el-col :span="5">部门：
					<el-input type="text" size="medium" v-model="newrow_dept" maxlength="80"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="5">职务：
					<el-input type="text" size="medium" v-model="newrow_duty" maxlength="80"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="5" :offset="1">手机号：
					<el-input type="text" size="medium" v-model="newrow_phone" maxlength="11"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="7">邮箱：
					<el-input type="text" size="medium" v-model="newrow_email" maxlength="100"  placeholder="请输入内容"></el-input>
				</el-col>
			</el-row>
			<div class="roomdata" v-if="switch_room == 'y'" >
				<el-row :gutter="20" class="pcpk">
					<el-col :span="20">需要住宿：
						<el-radio v-model="newrow_needroom" label="1">是</el-radio>
						<el-radio v-model="newrow_needroom" label="0">否</el-radio>
					</el-col>
				</el-row>
				<div v-if="newrow_needroom == '1'">
					<el-row :gutter="20" class="pcpk">
						<el-col :span="12"><span class="red_dot">*</span>选择房型：
							<el-select size="medium"  v-model="newrow_room_type" @change="handleSetAddRoomData" placeholder="请选择">
								<el-option
								v-for="items in room_list"
								:key="items.value"
								:label="items.label"
								:value="items.value">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="12" v-if="newrow_room_type == '标间'"><span class="red_dot">*</span>是否拼住：
							<el-radio v-model="newrow_spell_room" label="1">是</el-radio>
							<el-radio v-model="newrow_spell_room" label="0">否</el-radio>
						</el-col>

						<el-row :gutter="20" class="pcpk" v-if="newrow_spell_room == 1">
							<el-col :span="22" :offset="1" class="spell_detail">
								<el-radio-group v-model="newrow_roommate_type">
									<div class="checked_row">
										<el-radio :label="1">填写同住人</el-radio>
										<el-row :gutter="20" style="margin-top: 15px;">
											<el-col :span="8">
												<div class="checked_row_label">同住人姓名：</div>
												<el-input type="text" size="small" v-model="newrow_roommate_name" maxlength="20" placeholder="请输入内容"></el-input>
											</el-col>
											<el-col :span="15">
												<div class="checked_row_label">同住人手机尾号（后四位）：</div>
												<el-input type="text" size="small" v-model="newrow_roommate_phone" maxlength="4" placeholder="请输入内容"></el-input>
											</el-col>
										</el-row>
									</div>

									<div class="checked_row">
										<el-radio :label="2">无，系统匹配同性别拼住人</el-radio>
										<div class="panel_end_change_room" v-if="newrow_roommate_type == 2">
											<div class="soq_sss">若<strong>报名截止前</strong>未能匹配到拼住人，是否更换为大床房：</div>
											<el-radio-group v-model="newrow_end_change_room">
												<el-radio :label="'y'" class="ixx_row">是，更换为大床房</el-radio>
												<el-radio :label="'n'" class="ixx_row">否，保持标间</el-radio>
											</el-radio-group>
										</div>
									</div>

									<div class="clear"></div>
								</el-radio-group>
							</el-col>
						</el-row>

					</el-row>

					<el-row :gutter="20" class="pcpk">
						<el-col :span="12"><span class="red_dot">*</span>入住时间：
							<el-date-picker
								v-model="newrow_checkin"
								type="date"
								placeholder="选择日期" size="medium" style="width: 99%;" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
							</el-date-picker>
						</el-col>
						<el-col :span="12"><span class="red_dot">*</span>离店时间：
							<el-date-picker
								v-model="newrow_checkout"
								type="date"
								placeholder="选择日期" size="medium" style="width: 99%;" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
							</el-date-picker>
						</el-col>
					</el-row>
				</div>
			</div>

			<el-row :gutter="10" class="pcpk">
				<el-col :span="6">联系人：
					<el-input type="text" size="medium" v-model="newrow_contact_name" maxlength="50"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="9">手机号：
					<el-input type="text" size="medium" v-model="newrow_contact_phone" maxlength="11"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="9">接收发票邮箱：
					<el-input type="text" size="medium" v-model="newrow_contact_email" maxlength="100"  placeholder="请输入内容"></el-input>
				</el-col>
			</el-row>

			<el-row :gutter="20" class="pcpk">
				<el-col :span="10">发票抬头：
					<el-input type="text" size="medium" v-model="newrow_contact_tax_title" maxlength="200"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="9">税号：
					<el-input type="text" size="medium" v-model="newrow_contact_tax_no" maxlength="40"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="5" style="padding-top: 15px;">发票类型：
					<el-radio v-model="newrow_contact_tax_type" label="z">专票</el-radio>
					<el-radio v-model="newrow_contact_tax_type" label="p">普票</el-radio>
				</el-col>
			</el-row>

			<el-row :gutter="20" class="pcpk" >
				<el-col :span="14">银行账号：
					<el-input type="text" size="medium" v-model="newrow_contact_tax_number" maxlength="80"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="10">开户行：
					<el-input type="text" size="medium" v-model="newrow_contact_tax_bank" maxlength="140"  placeholder="请输入内容"></el-input>
				</el-col>
			</el-row>

			<el-row :gutter="20" class="pcpk" >
				<el-col :span="14">地址：
					<el-input type="text" size="medium" v-model="newrow_contact_tax_address" maxlength="220"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="10">电话：
					<el-input type="text" size="medium" v-model="newrow_contact_tax_tel" maxlength="15"  placeholder="请输入内容"></el-input>
				</el-col>
			</el-row>

			<div class="in_body_panel">
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24">发票特殊备注：
						<el-input type="textarea" :rows="2" size="medium" v-model="newrow_contact_tax_remark" maxlength="220" show-word-limit placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>
			</div>

			<div class="in_body_panel">
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24">备注：
						<el-input type="textarea" :rows="3" size="medium" v-model="newrow_remark" maxlength="220" show-word-limit placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogAddSingupVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleAddSingup">确 定</el-button>
			</div>
	</el-dialog>

	
	
	<el-dialog title="管理活动附件" :visible.sync="dialogUploadTopicsFile" width="70%">
		
		<el-row :gutter="20" >
			<el-col :span="24">
				<el-table
					:data="filesTableData"
					border 
					style="width: 100%" size="small">
					<el-table-column
					prop="show_name"
					label="文件名称">
					</el-table-column>
					<el-table-column
					prop="file_type"
					label="文件类型"
					width="80">
					</el-table-column>
					<!-- <el-table-column label="是否外显" >
						<template slot-scope="scope">
							<el-checkbox v-model="checked"></el-checkbox>
						</template>
					</el-table-column> -->
					<el-table-column label="操作" width="210">
						<template slot-scope="scope">
							<el-button type="warning" plain size="mini" @click="handleChangeFileName(scope.row)" >修改文件名</el-button>
							<el-button type="danger" plain size="mini" @click="handleDelFileRowData(scope.row)" >删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>

		<el-row :gutter="20" style="margin-top: 20px;">
			<el-col :span="24">
				<el-upload
				:show-file-list="false"
				class="upload-demo"
				action=""
				:http-request="handleClouldUpload">
				<el-button size="small" type="primary">点击上传文件</el-button>
				<div slot="tip" class="el-upload__tip">支持的文件格式：pdf、docx、doc、pptx、ppt、xls、xlsx、txt、jpg、gif、png</div>
				<div slot="tip" class="el-upload__tip" style="color: #ffffff;">上传后的文件将展示在报名页面上，如文件名不合适，可使用“修改文件名”功能。</div>
				</el-upload>
			</el-col>
		</el-row>
		
		<!-- <div slot="footer" class="dialog-footer">
			<el-button @click="dialogSingupDataVisible = false">取 消</el-button>
			<el-button type="primary" @click="handleSaveSingupData">确 定</el-button>
		</div> -->
	</el-dialog>

	</div>
</template>

<script>
import CommonNav from "@/components/Nav.vue";
import CommonHeader from "@/components/Header.vue";
import * as MN from '@/api/common';

export default {
    name: 'topicsDetail', 
	props:['selec'],
	data() {
		return {
			topics_singup_type:'',
			switch_is_self_edit:'',
			filesTableData:[],
			switch_room:'y',
			contactData:[],
			pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now(); 
                }
			},
			newrow_company_name:'',
			newrow_name:'',
			newrow_sex:'',
			newrow_dept:'',
			newrow_duty:'',
			newrow_phone:'',
			newrow_email:'',
			newrow_needroom:'',
			newrow_room_type:'',
			newrow_spell_room:'',
			newrow_checkin:'',
			newrow_checkout:'',

			newrow_roommate_name:'',
			newrow_roommate_phone:'',
			newrow_roommate_type:'',
			newrow_end_change_room:'',

			newrow_contact_name:'',
			newrow_contact_phone:'',
			newrow_contact_email:'',
			newrow_contact_tax_title:'',
			newrow_contact_tax_no:'',
			newrow_contact_tax_number:'',
			newrow_contact_tax_bank:'',
			newrow_contact_tax_address:'',
			newrow_contact_tax_tel:'',
			newrow_remark:'',
			newrow_contact_tax_type:'',
			newrow_contact_tax_remark:'',

			dialogUploadTopicsFile:false,
			dialogAddSingupVisible:false,
			topics_date_tips:'',
			topics_date:[],
			user_list:[],
			dialogSingupTitle:'',
			dialogSingupDataVisible:false,
			check_power:0,
			input_singup_user_uuid:'',
			input_singup_title:'',
			input_singup_introduction:'',
			edit_singup_uuid:'',
			topics_user_name:'',
			topics_datetime:'',
			sex_list:[
				{value: '男',label: '男'},
				{value: '女',label: '女'},
			],
			room_list:[
				{value: '大床',label: '大床'},
				{value: '标间',label: '标间'},
			],
			sbd_edit_rowid:'',
			sbd_edit_topics_uuid:'',
			sbd_company_name:'',
			sbd_name:'',
			sbd_sex:'',
			sbd_dept:'',
			sbd_duty:'',
			sbd_phone:'',
			sbd_email:'',
			sbd_needroom:'',
			sbd_room_type:'',
			sbd_spell_room:'',
			sbd_checkin:'',
			sbd_checkout:'',

			sbd_roommate_name:'',
			sbd_roommate_phone:'',
			sbd_roommate_type:'',
			sbd_end_change_room:'',
			sbd_contact_name:'',
			sbd_contact_phone:'',
			sbd_contact_email:'',
			sbd_contact_tax_title:'',
			sbd_contact_tax_no:'',
			sbd_contact_tax_number:'',
			sbd_contact_tax_bank:'',
			sbd_contact_tax_address:'',
			sbd_contact_tax_tel:'',
			sbd_remark:'',
			sbd_contact_tax_type:'',
			sbd_contact_tax_remark:'',

////////////////////////////////
			edit_singup_id:'',
			edit_name:'',
			edit_sex:'',
			edit_phone:'',
			edit_duty:'',
			edit_company:'',
			edit_cohabit_name:'',
			edit_cohabit_duty:'',
			edit_remark:'',
			edit_hasroom:false,
			edit_room_type:'',
			edit_checkin:'',
			edit_checkout:'',
			dialogEditSingupVisible:false,
			activeName:'customer',
			loading:true,
			boxshow: false, 
			curTipsID: '',
			userCount:0,
			detailData: [],
			detailList:[],
			detailUUID:this.$route.query.uuid,
			topicsLink:'',
			topicsQrcode:''
		}
	},
	components: {
		CommonNav,
		CommonHeader
	},
	created() {
		this.initData()
	},
	mounted() {

	},
	methods: {
		refreshFileList(){
			let me = this;
			me.loading = true
			let post={
				token:sessionStorage.getItem('subudian_token'),
				topics_uuid:me.detailUUID,
			}
			MN.getTopicsShowFileList(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				me.filesTableData=res.list;
				me.loading=false;
			})
		},
		handleClouldUpload(data,key){
			console.log("data.file",data.file);
			console.log("data.file.name",data.file.name);
			console.log("data.file.type",data.file.type);
			// let formdata_ = new FormData();
			let me = this;
			let doctype = data.file.name.split(".");
			let get_case_name = data.file.name;
			let Supplementkey = Date.now() + '_' + get_case_name;

			// me.fileNameList.push({
			// 	name:Supplementkey,
			// 	type:doctype[doctype.length - 1]
			// });

			me.show_upload_status_panel=true;

			let Bucket = 'wendao-1251754209';
			let Region = 'ap-beijing';
			var cos = new COS({
				getAuthorization: function (options, callback) {
					var url = 'https://api.subudian.com/subudian/index/uploadQCcloud';
					var xhr = new XMLHttpRequest();
					xhr.open('GET', url, true);
					xhr.onload = function (e) {
						try {
							var data = JSON.parse(e.target.responseText);
							var credentials = data.credentials;
						} catch (e) {
						}
						if (!data || !credentials) {
						return console.error('credentials invalid:\n' + JSON.stringify(data, null, 2))
						};
						callback({
						TmpSecretId: credentials.tmpSecretId,
						TmpSecretKey: credentials.tmpSecretKey,
						SecurityToken: credentials.sessionToken,
						StartTime: data.startTime,
						ExpiredTime: data.expiredTime,
					});
					};
					xhr.send();
				}
			});

			cos.uploadFile({
				Bucket: Bucket,
				Region: Region,
				Key: 'subudian/' +  Supplementkey,/* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */
				Body: data.file, // 上传文件对象
				SliceSize: 1024 * 1024 * 5,
				onProgress: function(progressData) {
					
					// let get_percent =  progressData.percent.toString().split('.');
					// me.upload_status_name=get_case_name;
					// me.upload_status_per=get_percent[1];

					// // var get_percent =  progressData.percent.toString().split('.')
					// if ( get_percent[0] == '1' ){
					// 	me.upload_status_per='100';
					// }else{
					// 	me.upload_status_per=get_percent[1];
					// }
					
					// console.log(JSON.stringify(progressData));
				}
			}, function(err, data) {
				let post={
					topics_uuid:me.detailUUID,
					token:sessionStorage.getItem('subudian_token'),
					file_name:Supplementkey,
					file_type:doctype[doctype.length - 1],
					show_name:get_case_name
				}
				MN.setNewUploadDataSave(post).then(res => {
					me.$message.success('上传成功');
					me.refreshFileList();
				});
			});
			
		},
		// aaa(){

		// 	cos.uploadFile({
        //         Bucket: 'wendao-1251754209',
        //         Region: 'ap-beijing',
        //         Key: dockey,/* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */
        //         Body: file, // 上传文件对象
        //         SliceSize: 1024 * 1024 * 5,
        //         onProgress: function(progressData) {
        //             console.log(progressData.percent)
        //         }
        //     }, function(err, data) {
              
        //     });
			
		// },
		handleShowUploadTopicsFile(){
			let me = this;
			me.refreshFileList();
			me.dialogUploadTopicsFile = true;
		},
		handleSetAddRoomData(e){
			console.log(e)
			let me = this;
			if ( e == '大床'){
				me.newrow_spell_room ='';
				me.newrow_roommate_name ='';
				me.newrow_roommate_phone ='';
				me.newrow_roommate_type ='';
				me.newrow_end_change_room ='';
			}
		},
		handleSetEditRoomData(e){
			console.log(e)
			let me = this;
			if ( e == '大床'){
				me.newrow_spell_room ='';
				me.newrow_roommate_name ='';
				me.newrow_roommate_phone ='';
				me.newrow_roommate_type ='';
				me.newrow_end_change_room ='';
			}
		},
		handleAddRowData(){
			this.newrow_company_name = '';
			this.newrow_name = '';
			this.newrow_sex = '';
			this.newrow_dept = '';
			this.newrow_duty = '';
			this.newrow_phone = '';
			this.newrow_email = '';
			this.newrow_needroom = '';
			this.newrow_room_type = '';
			this.newrow_spell_room = '';
			this.newrow_checkin = '';
			this.newrow_checkout = '';

			this.newrow_roommate_name = '';
			this.newrow_roommate_phone = '';
			this.newrow_roommate_type = '';
			this.newrow_end_change_room = '';

			this.newrow_contact_name = '';
			this.newrow_contact_phone = '';
			this.newrow_contact_email = '';
			this.newrow_contact_tax_title = '';
			this.newrow_contact_tax_no = '';
			this.newrow_contact_tax_number = '';
			this.newrow_contact_tax_bank = '';
			this.newrow_contact_tax_address = '';
			this.newrow_contact_tax_tel = '';
			this.newrow_remark = '';

			this.newrow_contact_tax_type = '';
			this.newrow_contact_tax_remark = '';

			this.dialogAddSingupVisible = true
		},
		getUserList(){
			let me = this;
			this.loading = true
			let post={
				token:sessionStorage.getItem('subudian_token')
      		}
			MN.getUserDataList(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				me.check_power = res.upower;
				let templist = [];
				for(let i=0; i < res.userlist.length; i++ ){
					templist.push({
						'value':res.userlist[i].uuid,
						'label':res.userlist[i].nickname
					});  
				}
				me.user_list=templist;
				me.loading=false;
			})
		},
		handleEditTopics(){
			this.getUserList();
			this.check_power=0;
			this.edit_singup_uuid = this.detailUUID;
			this.input_singup_title = this.detailData.topics_name;
			this.input_singup_introduction = this.detailData.introduction;
			this.topics_date_tips = this.detailData.date_tips;
			this.topics_date=[this.detailData.start_date.slice(0,10),this.detailData.end_date.slice(0,10)];
			this.dialogSingupTitle = '修改报名活动';
			this.dialogSingupDataVisible = true;
		},
		handleSaveSingupData(){

			if( !this.input_singup_title ){
				this.$message({
				message: '请填写标题',
				type: 'warning'
				});
				return
			}

			if( !this.topics_date || this.topics_date.length == 0 ){
				this.$message({
				message: '请选择活动日期',
				type: 'warning'
				});
				return
			}

			if( !this.topics_date_tips ){
				this.$message({
				message: '请填写日期提醒',
				type: 'warning'
				});
				return
			}

			let post={
				token:sessionStorage.getItem('subudian_token'),
				singup_title:this.input_singup_title,
				singup_introduction:this.input_singup_introduction,
				edit_singup_uuid:this.edit_singup_uuid,
				singup_user_uuid:this.input_singup_user_uuid,
				topics_date_tips:this.topics_date_tips,
				topics_start_date:this.topics_date[0],
				topics_end_date:this.topics_date[1],
				switch_room:this.switch_room,
				switch_is_self_edit:this.switch_is_self_edit,
				topics_singup_type:this.topics_singup_type
			}
			let me = this;
			MN.setSaveSingupData(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				if( res.status == 'add_ok' ){	
					me.$message({
						message: '创建成功',
						type: 'success'
					});
				}

				if( res.status == 'edit_ok' ){	
					me.$message({
						message: '修改成功',
						type: 'success'
					});
				}

				me.dialogSingupDataVisible = false;
				me.initData();
			})

		},
		handleOpenTopics(){
			this.$confirm('打开后将继续报名活动', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					topic_uuid:me.detailUUID
				}
				MN.setOpenTopics(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.initData();
					me.$message({
						type: 'success',
						message: '操作成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});          
			});
		},
		handleCloseTopics(){
			this.$confirm('关闭后将停止报名活动', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					topic_uuid:me.detailUUID
				}
				MN.setCloseTopics(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.initData();
					me.$message({
						type: 'success',
						message: '操作成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});          
			});
		},
		handleAddSingup(){
			let me = this;
			// if ( !this.newrow_company_name || !this.newrow_name || !this.newrow_sex ){
			// 	this.$message({
			// 		message: '请填写红色星号项目',
			// 		type: 'warning'
			// 	});
			// 	return
			// }

			// if ( !this.newrow_dept || !this.newrow_duty || !this.newrow_phone || !this.newrow_email ){
			// 	this.$message({
			// 		message: '请填写红色星号项目',
			// 		type: 'warning'
			// 	});
			// 	return
			// }

			// if ( this.newrow_needroom == '1' ){
			// 	if ( !this.newrow_checkin || !this.newrow_checkout ){
			// 		this.$message({
			// 			message: '请填写红色星号项目',
			// 			type: 'warning'
			// 		});
			// 		return
			// 	}
			// }
			if ( this.switch_room == 'y' ){
				if ( this.newrow_needroom == '1' ){
					if ( !this.newrow_room_type || !this.newrow_checkin || !this.newrow_checkout ){
						this.$message({
							message: '要住宿请把房型、入住离开日期都填一下',
							type: 'warning'
						});
						return
					}
					
					if ( this.newrow_checkin > this.newrow_checkout ){
						this.$message({
							message: '签到日期晚于离店日期',
							type: 'warning'
						});
						return
					}

					if ( this.newrow_room_type=='标间' && !this.newrow_spell_room ){
						this.$message({
							message: '标间请选择是否拼房',
							type: 'warning'
						});
						return
					}

					if ( this.newrow_spell_room == '1' && !this.newrow_roommate_type ){
						this.$message({
							message: '请选择拼房方式',
							type: 'warning'
						});
						return
					}

					if (  this.newrow_roommate_type == '1' && !this.newrow_roommate_name ){
						this.$message({
							message: '请填写拼住人姓名',
							type: 'warning'
						});
						return
					}

					if (  this.newrow_roommate_type == '1' && !this.newrow_roommate_phone ){
						this.$message({
							message: '请填写拼住人手机号后四位',
							type: 'warning'
						});
						return
					}

					if ( this.newrow_spell_room == '1' && this.newrow_roommate_type == '2' ){
						if( !this.newrow_end_change_room){
							this.$message({
								message: '请选择一下结束时是否换房',
								type: 'warning'
							});
							return
						}
					}
				}

			}else if ( this.switch_room == 'n' ){
				this.newrow_needroom ='';
				this.newrow_room_type ='';
				this.newrow_spell_room ='';
				this.newrow_checkin ='';
				this.newrow_checkout ='';
				this.newrow_roommate_name ='';
				this.newrow_roommate_phone ='';
				this.newrow_roommate_type ='';
				this.newrow_end_change_room ='';
			}


			if( this.newrow_phone && this.newrow_phone.length != 11 ){
				this.$message({
					message: '手机号格式错误',
					type: 'warning'
				});
				return
			}

			if( this.newrow_contact_phone && this.newrow_contact_phone.length != 11 ){
				this.$message({
					message: '联系人手机号格式错误',
					type: 'warning'
				});
				return
			}

			

			if ( me.newrow_spell_room == '1' && me.newrow_roommate_type == '1' ){
				me.newrow_end_change_room = "";
			}

			if ( me.newrow_spell_room == '1' && me.newrow_roommate_type == '2' ){
				me.newrow_roommate_name = "";
				me.newrow_roommate_phone = "";
			}

			if ( me.newrow_room_type == '大床' ){
				me.newrow_spell_room ='';
				me.newrow_roommate_name ='';
				me.newrow_roommate_phone ='';
				me.newrow_roommate_type ='';
				me.newrow_end_change_room ='';
			}

			if (me.newrow_needroom == '0' ){
				me.newrow_room_type ='';
				me.newrow_checkin ='';
				me.newrow_checkout ='';
				me.newrow_spell_room ='';
				me.newrow_roommate_name ='';
				me.newrow_roommate_phone ='';
				me.newrow_roommate_type ='';
				me.newrow_end_change_room ='';
			}
			
			let post={
				token:sessionStorage.getItem('subudian_token'),
				topics_uuid:me.detailUUID,
				// rowid:me.newrow_edit_rowid,
				company_name:me.newrow_company_name,
				name:me.newrow_name,
				sex:me.newrow_sex,
				dept:me.newrow_dept,
				duty:me.newrow_duty,
				phone:me.newrow_phone,
				email:me.newrow_email,
				needroom:me.newrow_needroom,
				room_type:me.newrow_room_type,
				spell_room:me.newrow_spell_room,
				checkin:me.newrow_checkin,
				checkout:me.newrow_checkout,
				roommate_name:me.newrow_roommate_name,
				roommate_phone:me.newrow_roommate_phone,
				roommate_type:me.newrow_roommate_type,
				end_change_room:me.newrow_end_change_room,

				contact_name:me.newrow_contact_name,
				contact_phone:me.newrow_contact_phone,
				contact_email:me.newrow_contact_email,
				contact_tax_title:me.newrow_contact_tax_title,
				contact_tax_no:me.newrow_contact_tax_no,
				contact_tax_number:me.newrow_contact_tax_number,
				contact_tax_bank:me.newrow_contact_tax_bank,
				contact_tax_address:me.newrow_contact_tax_address,
				contact_tax_tel:me.newrow_contact_tax_tel,
				remark:me.newrow_remark,
				contact_tax_type:me.newrow_contact_tax_type,
				contact_tax_remark:me.newrow_contact_tax_remark
			}
			
			MN.addTopicesSinglsRow(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				me.dialogAddSingupVisible=false;
				me.initData();
				me.$message({
					type: 'success',
					message: '添加成功!'
				});
			})


		},
		handleSaveEditSingupData(){
			let me = this;
			// if ( !this.sbd_company_name || !this.sbd_name || !this.sbd_sex ){
			// 	this.$message({
			// 		message: '请填写红色星号项目',
			// 		type: 'warning'
			// 	});
			// 	return
			// }

			// if ( !this.sbd_dept || !this.sbd_duty || !this.sbd_phone || !this.sbd_email ){
			// 	this.$message({
			// 		message: '请填写红色星号项目',
			// 		type: 'warning'
			// 	});
			// 	return
			// }

			// if ( this.sbd_needroom == '1' ){
			// 	if ( !this.sbd_checkin || !this.sbd_checkout ){
			// 		this.$message({
			// 			message: '请填写红色星号项目',
			// 			type: 'warning'
			// 		});
			// 		return
			// 	}
			// }

			
			if ( this.switch_room == 'y' ){

				if ( this.sbd_needroom == '1' ){
					if ( !this.sbd_room_type || !this.sbd_checkin || !this.sbd_checkout ){
						this.$message({
							message: '要住宿请把房型、入住离开日期都填一下',
							type: 'warning'
						});
						return
					}

					if ( this.sbd_checkin > this.sbd_checkout ){
						this.$message({
							message: '签到日期晚于离店日期',
							type: 'warning'
						});
						return
					}

					if ( this.sbd_room_type=='标间' && !this.sbd_spell_room ){
						this.$message({
							message: '标间请选择是否拼房',
							type: 'warning'
						});
						return
					}

					if ( this.sbd_spell_room == '1' && !this.sbd_roommate_type ){
						this.$message({
							message: '请选择拼房方式',
							type: 'warning'
						});
						return
					}

					if (  this.sbd_roommate_type == '1' && !this.sbd_roommate_name ){
						this.$message({
							message: '请填写拼住人姓名',
							type: 'warning'
						});
						return
					}

					if (  this.sbd_roommate_type == '1' && !this.sbd_roommate_phone ){
						this.$message({
							message: '请填写拼住人手机号后四位',
							type: 'warning'
						});
						return
					}

					if ( this.sbd_spell_room == '1' && this.sbd_roommate_type == '2' ){
						if( !this.sbd_end_change_room){
							this.$message({
								message: '请选择一下结束时是否换房',
								type: 'warning'
							});
							return
						}
					}

				}


			}else if ( this.switch_room == 'n' ){
				this.sbd_needroom ='';
				this.sbd_room_type ='';
				this.sbd_spell_room ='';
				this.sbd_checkin ='';
				this.sbd_checkout ='';
				this.sbd_roommate_name ='';
				this.sbd_roommate_phone ='';
				this.sbd_roommate_type ='';
				this.sbd_end_change_room ='';
			}

			if( this.sbd_phone && this.sbd_phone.length != 11 ){
				this.$message({
					message: '手机号格式错误',
					type: 'warning'
				});
				return
			}

			if( this.sbd_contact_phone && this.sbd_contact_phone.length != 11 ){
				this.$message({
					message: '联系人手机号格式错误',
					type: 'warning'
				});
				return
			}

			this.$confirm('是否确认保存修改?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {

				if (me.sbd_needroom == '0' ){
					me.sbd_room_type ='';
					me.sbd_checkin ='';
					me.sbd_checkout ='';
					me.sbd_spell_room ='';
					me.sbd_roommate_name ='';
					me.sbd_roommate_phone ='';
					me.sbd_roommate_type ='';
					me.sbd_end_change_room ='';
				}
				
				if ( me.sbd_spell_room == '1' && me.sbd_roommate_type == '1' ){
					me.sbd_end_change_room = "";
				}

				if ( me.sbd_spell_room == '1' && me.sbd_roommate_type == '2' ){
					me.sbd_roommate_name = "";
					me.sbd_roommate_phone = "";
				}

				if ( me.sbd_room_type == '大床' ){
					me.sbd_spell_room ='';
					me.sbd_roommate_name ='';
					me.sbd_roommate_phone ='';
					me.sbd_roommate_type ='';
					me.sbd_end_change_room ='';
				}

				if ( me.sbd_contact_tax_type == '专票' ){
					me.sbd_contact_tax_type ='z';
				}else if( me.sbd_contact_tax_type == '普票' ){
					me.sbd_contact_tax_type ='p';
				}

				let post={
					token:sessionStorage.getItem('subudian_token'),
					topics_uuid:me.sbd_edit_topics_uuid,
					rowid:me.sbd_edit_rowid,
					company_name:me.sbd_company_name,
					name:me.sbd_name,
					sex:me.sbd_sex,
					dept:me.sbd_dept,
					duty:me.sbd_duty,
					phone:me.sbd_phone,
					email:me.sbd_email,
					needroom:me.sbd_needroom,
					room_type:me.sbd_room_type,
					spell_room:me.sbd_spell_room,
					checkin:me.sbd_checkin,
					checkout:me.sbd_checkout,
					roommate_name:me.sbd_roommate_name,
					roommate_phone:me.sbd_roommate_phone,
					roommate_type:me.sbd_roommate_type,
					end_change_room:me.sbd_end_change_room,

					contact_name:me.sbd_contact_name,
					contact_phone:me.sbd_contact_phone,
					contact_email:me.sbd_contact_email,
					contact_tax_title:me.sbd_contact_tax_title,
					contact_tax_no:me.sbd_contact_tax_no,
					contact_tax_number:me.sbd_contact_tax_number,
					contact_tax_bank:me.sbd_contact_tax_bank,
					contact_tax_address:me.sbd_contact_tax_address,
					contact_tax_tel:me.sbd_contact_tax_tel,
					remark:me.sbd_remark,
					contact_tax_type:me.sbd_contact_tax_type,
					contact_tax_remark:me.sbd_contact_tax_remark
				}
				
				MN.editTopicesSinglsRow(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.dialogEditSingupVisible=false;
					me.initData();
					me.$message({
						type: 'success',
						message: '修改成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});          
			});
		},
		handleEditRowData(signup_data){
			console.log("signup_data",signup_data);

			this.sbd_edit_rowid = signup_data.id;
			this.sbd_edit_topics_uuid= signup_data.topics_uuid;

			this.sbd_company_name = signup_data.company_name;
			this.sbd_name = signup_data.name;
			this.sbd_sex = signup_data.sex;
			this.sbd_dept = signup_data.dept;
			this.sbd_duty = signup_data.duty;
			this.sbd_phone = signup_data.phone;
			this.sbd_email = signup_data.email;
			if ( signup_data.needroom == '需要' ){
				this.sbd_needroom = '1';
			}else if ( signup_data.needroom == '不需要' ){
				this.sbd_needroom = '0';
			}else{
				this.sbd_needroom = '';
			}
			this.sbd_room_type = signup_data.room_type;
			if ( signup_data.spell_room == '是' ){
				this.sbd_spell_room = '1';
			}else if ( signup_data.spell_room == '否' ){
				this.sbd_needroom = '0';
			}else{
				this.sbd_spell_room = '';
			}
			this.sbd_checkin = signup_data.checkin;
			this.sbd_checkout = signup_data.checkout;
	

			if ( signup_data.roommate_type == '自己指定' ){
				this.sbd_roommate_type = 1;
			}else if ( signup_data.roommate_type == '系统匹配' ){
				this.sbd_roommate_type = 2;
			}else{
				this.sbd_roommate_type = '';
			}

			if ( signup_data.end_change_room == '是，更换为大床房' ){
				this.sbd_end_change_room = 'y';
			}else if( signup_data.end_change_room == '否，保持标间' ){
				this.sbd_end_change_room = 'n';
			}else{
				this.sbd_end_change_room = '';
			}

			if ( signup_data.contact_tax_type == '专票' ){
				this.sbd_contact_tax_type = 'z';
			}else if( signup_data.contact_tax_type == '普票' ){
				this.sbd_contact_tax_type = 'p';
			}else{
				this.sbd_contact_tax_type = '';
			}
			this.sbd_contact_tax_remark = signup_data.contact_tax_remark;

		
			this.sbd_roommate_name = signup_data.roommate_name;
			this.sbd_roommate_phone = signup_data.roommate_phone;

			this.sbd_contact_name = signup_data.contact_name;
			this.sbd_contact_phone = signup_data.contact_phone;
			this.sbd_contact_email = signup_data.contact_email;
			this.sbd_contact_tax_title = signup_data.contact_tax_title;
			this.sbd_contact_tax_no = signup_data.contact_tax_no;
			this.sbd_contact_tax_number = signup_data.contact_tax_number;
			this.sbd_contact_tax_bank = signup_data.contact_tax_bank;
			this.sbd_contact_tax_address = signup_data.contact_tax_address;
			this.sbd_contact_tax_tel = signup_data.contact_tax_tel;
			this.sbd_remark = signup_data.remark;

			if ( this.sbd_spell_room == '1' && this.sbd_roommate_type == '1' ){
				this.sbd_end_change_room = "";
			}

			if ( this.sbd_spell_room == '1' && this.sbd_roommate_type == '2' ){
				this.sbd_roommate_name = "";
				this.sbd_roommate_phone = "";
			}

			if ( this.sbd_room_type == '大床' ){
				this.sbd_spell_room ='';
				this.sbd_roommate_name ='';
				this.sbd_roommate_phone ='';
				this.sbd_roommate_type ='';
				this.sbd_end_change_room ='';
			}
		
			// this.sbd_roommate_type = signup_data.roommate_type;

			// this.sbd_end_change_room = signup_data.end_change_room;


			this.dialogEditSingupVisible=true;

		},
		handleChangeFileName(rowData) {
			let me = this;
			this.$prompt('请输入新的文件名', '提示', {
				confirmButtonText: '保存',
				cancelButtonText: '取消',
				inputValidator: (value) => {
					if (!value) {
						return '输入不能为空';
					}
					if (value.length < 10) {
						return '输入长度不能小于10个字符';
					}
					if (value.length > 200) {
						return '输入长度不能大于200个字符';
					}
					return true;
				}
			}).then(({ value }) => {
				let post={
					token:sessionStorage.getItem('subudian_token'),
					topics_uuid:rowData.topics_uuid,
					rowid:rowData.id,
					show_name:value
				}
				MN.setTopicesFileName(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.refreshFileList();
					me.$message({
						type: 'success',
						message: '保存文件名成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '取消输入'
				});       
			});
      	},
		handleDelFileRowData(rowData){
			this.$confirm('是否确认删除此文件?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					topics_uuid:rowData.topics_uuid,
					rowid:rowData.id
				}
				MN.delTopicesSinglsFileRow(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.refreshFileList();
					me.$message({
						type: 'success',
						message: '删除成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});          
			});
		},
		handleDelRowData(rowData){
			this.$confirm('是否确认删除此行?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					topics_uuid:rowData.topics_uuid,
					rowid:rowData.id
				}
				MN.delTopicesSinglsRow(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.initData();
					me.$message({
						type: 'success',
						message: '删除成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});          
			});
		},
		initData(){
			let me = this;
			this.loading = false
			let post={
				token:sessionStorage.getItem('subudian_token'),
				uuid:this.detailUUID
			}
			MN.getTopicsDetail(post).then(res => {

				me.topics_user_name = res.data.create_user_name;
				me.topics_datetime = res.data.create_date;

				me.topics_nickname = res.data.nickname;
				me.detailData = res.data;
				me.detailList = res.list;
				me.userCount = res.count;
				me.topicsLink = res.data.topics_link;
				me.topicsQrcode = res.data.topics_qrcode;
				me.switch_room = res.data.switch_room;
				me.switch_is_self_edit = res.data.is_self_edit;
				me.topics_singup_type = res.data.topics_singup_type;
				me.loading = false;
			})
		},
		handleGoBack(){
			this.$router.back(-1)
		}
	}
}
</script>

<style scoped>
.roomdata{ background-color:#e1f7ff; padding:1% 2% 2% 2%; margin: 12px 0 0 0; border-radius: 4px; }
.soq_sss{ padding: 10px; font-size: 13px; margin-bottom: 5px; }
.clear{ clear: both; }
.checked_row{ margin-bottom: 25px; }	
.checked_row_label{ margin-bottom: 5px; font-size: 14px; }
.sixo{ margin-bottom: 15px;  }
.spell_detail{ background-color: #f7ffff; padding-top: 20px; border-radius: 8px; margin-top: 8px;  }
.panel_end_change_room{ background-color: #fffdeb; margin: 10px 0 10px 0; padding: 15px; border-radius: 10px; }
.buttonexcel{
	background: none;
	background-color: #409eff;
	width: 140px;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 6px;
	cursor: pointer;
	float: right;
	margin-right: 10px;
}

.buttonexcel_caiwu{
	background: none;
	background-color: #4a6bcb;
	width: 140px;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 6px;
	cursor: pointer;
	float: right;
	margin-right: 10px;
}
.page_bar_title{
	color: #575757;
}
.mt20{
	margin-top: 20px;
}
.detail_row{
	background-color: #f8f8f8;
	border-radius: 10px;
	padding: 8px;
	box-shadow: 0 2px 5px #eeeeee;
	text-align: left;
	margin-top: 10px;
}	
.red_dot{ color: #ff693f; font-size: 13px; }
.pcpk{font-size: 14px; margin-top: 15px;  }
</style>
